import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

import { transformDispatcher } from "@/analytics/rootDispatcher";

interface AgentAttributesStore {
    site: string | undefined;
    setAgentSite: (site?: string) => void;
}

export const useAgentAttributesStore = createWithEqualityFn<AgentAttributesStore>()(
    persist(
        immer(
            devtools(
                (set) => ({
                    site: undefined,
                    setAgentSite(site?: string) {
                        set(
                            {
                                site,
                            },
                            false,
                            "setAgentSite",
                        );
                        if (site) {
                            transformDispatcher((dispatcher) => dispatcher.withIdentities({ Site: site }));
                        }
                    },
                }),
                {
                    enabled: import.meta.env.VITE_ENV_TYPE !== "production",
                    store: "agent-attributes-store",
                    name: "workspace/sdk",
                },
            ),
        ),
        { name: "agent-attributes-store", skipHydration: true },
    ),
    shallow,
);
